export default "__VITE_ASSET__ea2425f0__"